import { Component, Inject, Input } from '@angular/core';
import { AJSMmbUtilService, AJSMmbUtilServiceType } from '@src/components/services/Utils/ib-mmb-utils-bridge.service';
import { CommonsSessionStorageService, downgradeToAJSComponent } from 'ib-web-commons/utils';
import { MmBUtilService } from '@src/components/services/Utils/ib-MmB-utils';

@Component({
  selector: 'ib-cash-avios-info',
  templateUrl: './ib-cash-avios-info.component.html'
})
export class IbCashAviosInfoComponent {

  @Input() cashAviosModel;
  isUserLogged:boolean;

  constructor (
    private CommonsSessionStorageService: CommonsSessionStorageService,
    @Inject(AJSMmbUtilService) private MmBUtilService: AJSMmbUtilServiceType,
  ) {
    this.isUserLogged = this.CommonsSessionStorageService.get('userLogged');
  }

  public scrollToLogin = () => {

    const isMobile = this.MmBUtilService.isMobile();
    let loginElement;

    if (isMobile.general) {
        loginElement = document.querySelector('#menus-header-grey-bar-login-link-mobile');
    } else {
        loginElement = document.querySelector('#menus-header-grey-bar-login-link');
    }
    loginElement.click();

  };
}

downgradeToAJSComponent('ibCashAviosInfo', {
  component: IbCashAviosInfoComponent,
  inputs: ['cashAviosModel'] },
'ib-cash-avios-info-module');
